import React, { createContext } from 'react';
import { compose, omit, is, pipe, keys, head } from 'ramda';
import { set } from '@synergycms_core/utils';

import styleFile from './tabList.js';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import Button from '@synergycms_core/components/generic/Button';

const TabContext = createContext({});

export const TabTitle = compose(
  PropertyManager(['showTab', 'selectedKey', 'selected', 'children', 'selectedClass', 'disabled']),
  withThemeJSS({ styleFile }, null, 'tabTitle')
)(
  class TabTitle extends React.Component {
    static displayName = "TabList";
    render() {
      const { showTab, selected, selectedKey, selectedClass, disabled } = this.props.config;
      const { computedInnerStyle } = this.props.theme;
      const { classes } = this.props.theme.styles;
      return (
        <Button
          onClick={!disabled && showTab(selectedKey)}
          richText={!React.isValidElement(this.props.children) && { defaultStyle: false }}
          config={{
            ...(!React.isValidElement(this.props.children) ? this.props.config : {}),
            innerStyle: [computedInnerStyle, selected ? selectedClass || classes.selected : '']
          }}
          innerStyle={['tabListButton']}
        >
          {this.props.children}
        </Button>
      );
    }
  }
);

export const WrapperTabs = compose(
  PropertyManager(['showTab', 'selectedKey', 'selected', 'contentBlockStyle', 'titleBlockStyle', 'selectedClass', 'onTabChange', 'hideSingleTab']),
  withThemeJSS({ styleFile })
)(
  class WrapperTabs extends React.Component {
    constructor(props, context) {
      super(props);

      this.state = {
        tabList: {},
        selectedKey: null
      };

      context.subscribe(this.subscribeTab, this.showTab);
      context.unSubscribe(this.unSubscribeTab);
    }
    static displayName = "TabList";
    static contextType = TabContext;

    subscribeTab = tab => {
      this.setState(state => {
        return {
          selectedKey: state.selectedKey === null || state.selectedKey === undefined ? tab.key : state.selectedKey,
          tabList: set(tab.key, tab, state.tabList)
        };
      });
    };

    unSubscribeTab = key => {
      this.setState(state => {
        const tabList = omit([key], state.tabList);
        let selectedKey = state.selectedKey;
        if(state.selectedKey === key){
          selectedKey = pipe(keys,head)(tabList);
        }
        return { selectedKey, tabList };
      });
    };

    showTab = key => e => {
      e && e.preventDefault();
      if (this.state.tabList[key]) {
        this.setState((state, props) => ({
          selectedKey: key
        }),()=>{

          const { onTabChange } = this.props.config;
          onTabChange && onTabChange(this.state.selectedKey);
        });
      }
    };

    render() {
      //const { showTab, selected, selectedKey } = this.props.config;
      //const { computedInnerStyle } = this.props.theme;
      const { selectedKey, tabList } = this.state;
      const { theme, config } = this.props;
      const { contentBlockStyle, titleBlockStyle, hideSingleTab } = config;
      const { classes } = theme.styles;
      const tabsCount = Object.keys(tabList).length;

      const hideTabs = hideSingleTab && tabsCount === 1;
      return (
        !!tabsCount && (
          <div className={theme.computedInnerStyle}>
            {!hideTabs && tabList &&<div>
              <ul className={theme.styleGetterEscape(titleBlockStyle || classes.titleListBlock)}>
                {Object.values(tabList).map(tab => {
                    return (
                      <li key={tab.key}>
                        <TabTitle
                          config={
                            !React.isValidElement(tab.tabTitle) &&
                            (!is(String, tab.tabTitle) ? tab.tabTitle : { text: tab.tabTitle })
                          }
                          selectedKey={tab.key}
                          selectedClass={this.props.config.selectedClass}
                          showTab={this.showTab}
                          selected={selectedKey === tab.key}
                          disabled={tab.disabled}>
                          {React.isValidElement(tab.tabTitle) && tab.tabTitle}
                        </TabTitle>
                      </li>
                    );
                })}
              </ul>
            </div>}
            {tabList &&
              Object.values(tabList).map(tab => {
                return (
                  <div
                    key={tab.key}
                    style={{ display: (hideTabs || selectedKey === tab.key) ? 'block' : 'none', height: (hideTabs || selectedKey === tab.key) ? '100%' : 'auto',}}
                    ref={config.callbackRef || null}
                    className={theme.styleGetterEscape(contentBlockStyle || classes.contentBlock)}>
                    {tab.content}
                  </div>
                );
              })}
          </div>
        )
      );
    }
  }
);
export const Tab = compose(
  PropertyManager(['tabTitle', 'contentKey', 'children', 'disabled']),
  withThemeJSS({ styleFile }, null, 'tabContent')
)(
  class Tab extends React.Component {
    static contextType = TabContext;
    static displayName = "TabList";
    componentDidUpdate = () => {
      this.updateDataTab();
    };
    componentDidMount = () => {
      this.updateDataTab();
    };
    componentWillUnmount = () => {
      if (this.context.unSubscribeTab) {
        this.context.unSubscribeTab(this.props.config.contentKey);
      }
    };
    updateDataTab = () => {
      if (this.context.subscribeTab) {
        this.context.subscribeTab({
          key: this.props.config.contentKey,
          tabTitle: this.props.config.tabTitle,
          disabled: this.props.config.disabled || false,
          content: <div className={this.props.theme.computedInnerStyle}>{this.props.children}</div>
        });
      }
    };
    render = () => {
      //const { children, theme } = this.props;
      return null;
    };
  }
);
//TODO s'hauria de comprovar l'eficiencia dels TabContent, automaticament s'estableix una key, tot i q realment només es mostra 1
const Tabs = class Tabs extends React.Component {
  constructor(props) {
    super(props);
    let selected;
    this.state = {
      selectedKey: selected || null,
      subscribeTab: null,
      unSubscribeTab: null,
      showTab: null,
      ready: false
    };
  }
  static displayName = "TabList";
  unSubscribe = unSubscribeTab => {
    !this.state.unSubscribeTab && this.setState({ unSubscribeTab: unSubscribeTab });
  };
  subscribe = (subscribeTab, showTab) => {
    !this.state.subscribeTab && this.setState({ subscribeTab: subscribeTab });
    this.showTab = showTab;
  };

  render() {
    const children = this.props.children;

    
    return (
      <React.Fragment>
        <TabContext.Provider
          value={{
            subscribe: this.subscribe,
            subscribeTab: this.state.subscribeTab,
            unSubscribe: this.unSubscribe,
            unSubscribeTab: this.state.unSubscribeTab
          }}>
          <WrapperTabs
            hideSingleTab={this.props.config.hideSingleTab}
            innerStyle={this.props.config.innerStyle}
            selectedClass={this.props.config.selectedClass}
            contentBlockStyle={this.props.config.contentBlockStyle}
            titleBlockStyle={this.props.config.titleBlockStyle}
            onTabChange={this.props.config.onTabChange}
          />
            {this.state.subscribeTab && children && (typeof children === 'function' ? children(this.showTab) : children)}
        </TabContext.Provider>
      </React.Fragment>
    );
  }
};

export default compose(
  PropertyManager([
    'contentBlockStyle',
    'titleBlockStyle',
    'callbackRef',
    'children',
    'selectedClass',
    'containerTabsSytle',
    'onTabChange',
    'hideSingleTab'
  ]),
  withThemeJSS({ styleFile, link: true })
)(Tabs);
